import React from 'react';

import { Separator } from 'kards-components';

export default ({ data }) => <Separator data={data} />;
